import { z } from 'zod';

/** Either a plain string or a map locale → string. */
export const LocalizedStringSchema = z.union([
  z.string().max(1000),
  z.record(z.string().regex(/^[a-z]{2}(-[A-Z]{2})?$/), z.string().max(1000)),
]);
export type LocalizedString = z.infer<typeof LocalizedStringSchema>;

export function resolveLocalized(s: LocalizedString | undefined, locale: string, fallback = 'en'): string {
  if (s === undefined) return '';
  if (typeof s === 'string') return s;
  return s[locale] ?? s[locale.slice(0, 2)] ?? s[fallback] ?? Object.values(s)[0] ?? '';
}
